import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

const TABS = [
  { value: 'overview', label: 'Overview', disabled: false },
  { value: 'financials', label: 'Financials', disabled: false },
  { value: 'kpis', label: 'Scorecard', disabled: false },
  { value: 'management', label: 'Management', disabled: true },
  { value: 'transactions', label: 'Transactions', disabled: true },
  { value: 'cap-table', label: 'Cap Table', disabled: true },
  { value: 'general', label: 'General', disabled: true },
] as const

export type CompanyDetailTabValue = (typeof TABS)[number]['value']

export function isTabValue(value: string): value is CompanyDetailTabValue {
  return TABS.some((tab) => tab.value === value)
}

export function CompanyDetailTabs({
  value,
  onValueChange,
  showScorecard,
}: {
  value: CompanyDetailTabValue
  onValueChange: (value: CompanyDetailTabValue) => void
  showScorecard: boolean
}) {
  const tabs = TABS.filter((tab) => showScorecard || tab.value !== 'kpis')

  return (
    <Tabs
      value={value}
      onValueChange={(next) => {
        if (isTabValue(next)) onValueChange(next)
      }}
      className="w-fit max-w-full"
    >
      <TabsList className="inline-flex h-auto max-w-full flex-wrap justify-start gap-1 rounded-md bg-secondary/8 p-1">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            id={`company-detail-tab-${tab.value}`}
            aria-controls="company-detail-tabpanel"
            value={tab.value}
            disabled={tab.disabled}
            className="h-auto text-xs sm:text-sm data-[state=active]:px-2 data-[state=active]:py-1"
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
